function getUrlParam(url: string, name: string) {
  const search = url.substring(url.indexOf('?'));
  const searchParams = new URLSearchParams(search);
  return searchParams.get(name);
}

export default getUrlParam;
